<template>
  <q-select
    v-model="terms"
    :class="{ required: required }"
    dense
    outlined
    :clearable="$attrs.clearable !== false"
    use-input
    emit-value
    map-options
    options-dense
    fill-input
    hide-selected
    hide-bottom-space
    :options="commissionWeekOptions"
    :label="getLabel"
    :error="error"
    :error-message="errorMessage"
    :disable="disable"
    :readonly="readonly"
    @filter="search"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
        <q-item-section>
          <q-item-label v-html="scope.opt.label" />
          <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          {{ $t('Common.NoResult.Text') }}
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CWSearchField',
  props: {
    value: {},
    label: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectDefault: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: [Object, Boolean],
    },
  },
  data: () => ({
    terms: '',
    commissionWeekOptions: [],
  }),
  watch: {
    terms: {
      handler(to) {
        this.$emit('input', to)
        this.$emit('callback')
      },
    },
    selected: {
      handler(to) {
        this.commissionWeekOptions.push(to)
        this.terms = to.value || null
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      commissionWeeks: state => state.globalCMP.commissionWeeks.list,
    }),
    getLabel() {
      return this.label || this.$ts('labels.payCycle')
    },
  },
  async mounted() {
    let payload = {
      ...{
        filter_type: 'current_past',
      },
      ...this.payload,
    }
    await this.getCommissionWeekSearchAction(payload)
    if (this.selectDefault && !this.selected) {
      this.commissionWeekOptions = [...this.commissionWeeks]
      this.terms = this.value ? this.value : this.$helpers.getValue(this.commissionWeekOptions, '[0].value', null)
    }
  },
  methods: {
    ...mapActions(['getCommissionWeekSearchAction']),
    async search(terms, update) {
      let filterOptions = [...this.commissionWeeks]
      if (this.selected) {
        filterOptions = [...filterOptions, ...[this.selected]]
      }
      if (terms !== '') {
        update(() => {
          this.commissionWeekOptions = filterOptions.filter(x => x.label.includes(terms))
        })
      } else {
        update(() => {
          this.commissionWeekOptions = filterOptions
        })
      }
    },
  },
}
</script>
